module.exports = __webpack_public_path__ + "static/img/4bg_7.fd427a2.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/4bg_7.png
// module id = 718
// module chunks = 1